import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import 'font-awesome/css/font-awesome.min.css';
import { logoutRequest } from "../../authConfig";
import { Cookies } from 'react-cookie';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { AdminService } from '../admin/AdminService';

//JIRA - HM-425 & HM-459 Bug Fix without Redirect login flow
function removeMsalInteractionFromCookies(cookies) {
    let cookieExits = cookies.get('msal.interaction.status', { path: '/' });
    if (cookieExits !== undefined && cookieExits !== null) {
        //console.log(cookieExits);
        cookies.remove('msal.interaction.status', { path: '/' });
        //console.log(cookies.getAll());
    }
}

function handleLogout(instance, cookies) {

    //console.log("handleLogout")
    removeMsalInteractionFromCookies(cookies);

    instance.logoutRedirect(logoutRequest).catch(e => {
        window.localStorage.clear();
        window.sessionStorage.clear();
        console.error(e);
    });
}
/**
 * Renders a button which, when selected, will redirect the page to the logout prompt
 */
function SignOutButton(props) {
    const { instance } = useMsal();
    const [cookies] = useState(() => new Cookies());
    const adminService = new AdminService();
    const [switchOptionDialog, setswitchOptionDialogFlag] = useState(false);
    const [adminRoles, setAdminRoles] = useState(null);

    const dialogFuncMap = {
        'switchOptionDialog': setswitchOptionDialogFlag,
    }
    const onHide = (name) => {
        dialogFuncMap[`${name}`](false);
    }
    const onClick = (name, position) => {
        dialogFuncMap[`${name}`](true);
    }

    const getAdminRoles = () => {
        let msalContext = { accounts: instance.getAllAccounts() };
        adminService.getAdminRoles(msalContext).then(
            (d) => {
                setAdminRoles(d);
            }
        ).catch(e => {
            console.log(e)
        });
    }

    useEffect(() => {
        getAdminRoles() //HDO-8090 - to get the user role and show/hide action column accordingly
    }, [])

    return (
        <>
            <div className="ml-auto">
                <div className="btn-group">
                    <button type="button" className="btn btn-primary">
                        <b><i className="fa fa-user-circle"></i> &nbsp; {props.account.name}</b>
                    </button>
                    <button type="button" className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span className="sr-only">Toggle Dropdown</span>
                    </button>
                    <div className="dropdown-menu dropdown-menu-right">
                        <div className="dropdown-item-text">{props.account.username}</div>
                        {/* HDO-8116 - to show the roles in dropdown if user has any role */}
                        {adminRoles ? <>
                            <div className="dropdown-divider"></div>
                            <div className="dropdown-item-text"><span>{adminRoles.join(', ')}</span></div>
                        </> : ''}
                        < div className="dropdown-divider"></div>
                        <button className="dropdown-item" onClick={() => onClick('switchOptionDialog')}>
                            Switch Environment <i className="fa fa-random"></i>
                        </button>
                        <div className="dropdown-divider"></div>
                        <button className="dropdown-item" onClick={() => handleLogout(instance, cookies)}>
                            <b> Sign Out </b> <i className="fa fa-sign-out"></i>
                        </button>
                    </div>
                </div>

                <Dialog header='Switch Environment'
                    visible={switchOptionDialog} modal={true}
                    onHide={() => onHide('switchOptionDialog')} maximizable={false}>
                    <div>
                        <table>
                            <tr>
                                <td><Button label="DEV/iDEV" className="p-button-raised" onClick={() => window.open('https://monitoringtool.dev.northwell.io/', "_self")} /></td>
                                <td><Button label="QA" className="p-button-raised" onClick={() => window.open('https://monitoringtool.qa.northwell.io/', "_self")} /></td>
                                <td><Button label="STAGE" className="p-button-raised" onClick={() => window.open('https://monitoringtool.stg.northwell.io/', "_self")} /></td>
                                <td><Button label="PROD" className="p-button-raised" onClick={() => window.open('https://monitoringtool.northwell.io/', "_self")} /></td>
                            </tr>
                        </table>
                    </div>
                </Dialog>
            </div >
        </>
    );
}

export { SignOutButton };